var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IDebugRepositoryType, inject, injectable, IPayloadRepositoryType, Observable } from '@serviceos-rn/core';
import { TipConfig } from '../../TipConfig';
let TipPayloadRepository = class TipPayloadRepository {
    constructor(payloadRepository, debugRepository) {
        this.payloadRepository = payloadRepository;
        this.debugRepository = debugRepository;
        this.bookingID = new Observable();
        this.transactionId = new Observable();
        this.position = new Observable();
        this.mode = new Observable();
        this.tipOptions = new Observable();
        this.showSuccessPage = new Observable(true);
        this.integrated = new Observable(true);
        this.payloadRepository.getPayload(TipConfig.moduleName).observe(this, value => {
            this.bookingID.next(value.booking_id);
            this.mode.next(value.mode || 'normal');
            this.tipOptions.next(value.choice);
            this.integrated.next(!!value.integrated);
            this.transactionId.next(value.booking_transaction_id);
            this.position.next(value.position);
            const showSuccessPage = value.show_success_page === undefined
                ? true
                : false;
            this.showSuccessPage.next(showSuccessPage);
            this.debugRepository.send({
                type: 'tip_payload',
                data: Object.assign({}, value)
            });
        });
    }
    getTransactionId() {
        return this.transactionId;
    }
    getPosition() {
        return this.position;
    }
    getIntegrated() {
        return this.integrated;
    }
    getBookingID() {
        return this.bookingID;
    }
    getMode() {
        return this.mode;
    }
    getTip() {
        return this.tipOptions;
    }
    getShowSuccessPage() {
        return this.showSuccessPage;
    }
    updatePayload(update) {
        return this.payloadRepository.updatePayload(TipConfig.moduleName, update);
    }
};
TipPayloadRepository = __decorate([
    injectable({
        type: 'singleton'
    }),
    __param(0, inject(IPayloadRepositoryType)),
    __param(1, inject(IDebugRepositoryType)),
    __metadata("design:paramtypes", [Object, Object])
], TipPayloadRepository);
export { TipPayloadRepository };
